/* eslint-disable */
import { createSelector } from 'reselect';
import getFilters from './Filters.selector';

/**
 * Selects the selected `account` from `filters`
 * @returns {any} The account
 */
const getFiltersSelectedAccount = createSelector(
  getFilters,
  ({ account }) => account,
);

export default getFiltersSelectedAccount;
